import LabeledSelect from "./LabeledSelect";
import React, {useEffect} from "react";
import {FOCUSED_ITEMS_OTHERS_LIST, FOCUSED_ITEMS_OTHERS_TYPE} from "../../pages/focusItems/enums";
import {isValidWebUrl} from "../../helpers/validationHelper";
import CustomMessage from '../CustomMessage'

const FocusedOtherSelect = ({
                              label, value, onChange, type, placeholder = "Select",
                              emptyMsg = "No data", extData, ...props
                            }) => {

  useEffect(() => {
    if (extData) {
      const _data = extData === FOCUSED_ITEMS_OTHERS_TYPE.noLink  ? FOCUSED_ITEMS_OTHERS_LIST[0] :
        isValidWebUrl(extData)  ? FOCUSED_ITEMS_OTHERS_LIST[1] :
          FOCUSED_ITEMS_OTHERS_LIST[2];
      onChange({
        ..._data,
        ...(extData !== FOCUSED_ITEMS_OTHERS_TYPE.noLink && {edit: extData})
      });
    }
  }, [extData]);

  return (
    <LabeledSelect label={label} value={value} options={FOCUSED_ITEMS_OTHERS_LIST}
                   placeholder={placeholder}
                   onChange={onChange} emptyMsg={emptyMsg} {...props}/>
  );
};

export const FocusedOtherPvSelect = ({
                              label, value, ...props
                            }) => {


  return (
    <CustomMessage message="Please do not type randomly. Copy it from the web app. It may behave differently if this value is not proper." messageType="warning" className="mb-3" />
  );
};

export default FocusedOtherSelect;
